/* ============================================================================
   GODS · Flechas del riel de upsell del cart drawer
   Creado 2026-09-08.

   POR QUE existe: el riel scrollea en horizontal y su barra esta oculta
   (assets/cart-upsell-gods.css). Con el dedo se arrastra, pero en desktop con
   mouse la unica salida era shift+scroll — o sea, ninguna. Estas flechas son
   el affordance para punteros finos.

   POR QUE TODO ES DELEGADO en document y no hay init por elemento: el cart
   drawer se RE-RENDERIZA por la API de secciones en cada cambio del carrito,
   asi que cualquier listener pegado al riel se pierde al primer "Agregar".
   Los listeners en document sobreviven; los botones viven en el Liquid
   (snippets/cart-block-upsell.liquid) por la misma razon.

   NO se intercepta el wheel a proposito: el drawer scrollea en vertical y
   robarle la rueda al usuario romperia el scroll de la lista del carrito.
============================================================================ */
(function () {
  'use strict';

  var TOLERANCIA = 2; // px de holgura: scrollLeft es fraccional con zoom/DPR

  function riel(wrap) {
    return wrap && wrap.querySelector('.cart__widget__products');
  }

  // Marca los extremos para que el CSS apague la flecha que no lleva a ningun
  // lado, y esconde las dos cuando no hay nada que scrollear (1 solo producto).
  function sincronizar(wrap) {
    var r = riel(wrap);
    if (!r) return;
    var scrollable = r.scrollWidth - r.clientWidth > TOLERANCIA;
    wrap.classList.toggle('is-not-scrollable', !scrollable);
    wrap.classList.toggle('is-at-start', r.scrollLeft <= TOLERANCIA);
    wrap.classList.toggle(
      'is-at-end',
      r.scrollLeft >= r.scrollWidth - r.clientWidth - TOLERANCIA
    );
  }

  function sincronizarTodos() {
    var wraps = document.querySelectorAll('[data-upsell-rail]');
    for (var i = 0; i < wraps.length; i++) sincronizar(wraps[i]);
  }

  // --- click en una flecha: avanza una tarjeta ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-upsell-scroll]');
    if (!btn) return;
    var wrap = btn.closest('[data-upsell-rail]');
    var r = riel(wrap);
    if (!r) return;
    e.preventDefault();

    // el paso es el ancho real de una tarjeta + el gap, leido del DOM: el
    // ancho de tarjeta es un % que cambia por viewport (--gods-upsell-card-w)
    var card = r.querySelector('quick-add-product');
    var gap = parseFloat(getComputedStyle(r).columnGap || getComputedStyle(r).gap) || 10;
    var paso = card ? card.getBoundingClientRect().width + gap : r.clientWidth * 0.8;

    r.scrollBy({
      left: paso * (Number(btn.getAttribute('data-upsell-scroll')) || 1),
      behavior: 'smooth',
    });
  });

  // --- scroll del riel: `scroll` NO burbujea, por eso va en fase de captura ---
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('cart__widget__products')) {
        sincronizar(t.closest('[data-upsell-rail]'));
      }
    },
    true
  );

  // --- el drawer se re-renderiza y el acordeon nace cerrado (ancho 0) ---
  document.addEventListener('DOMContentLoaded', sincronizarTodos);
  window.addEventListener('resize', sincronizarTodos);
  // el acordeon anima su alto: al abrirlo el riel recien ahi tiene medidas
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-collapsible-trigger]')) {
      setTimeout(sincronizarTodos, 450);
    }
  });

  // el cart drawer se re-renderiza por la API de secciones en cada cambio del
  // carrito: observar su subarbol es lo que mantiene las flechas correctas sin
  // pollear. Debounced porque el re-render dispara muchas mutaciones seguidas.
  var pendiente;
  var observer = new MutationObserver(function () {
    clearTimeout(pendiente);
    pendiente = setTimeout(sincronizarTodos, 120);
  });
  function observar() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observar);
  } else {
    observar();
  }

  sincronizarTodos();
})();

/* ============================================================================
   GODS 2026-09-09 - Pills de variante: 1 tap para agregar.

   POR QUE NO se hace fetch propio a /cart/add.js: el theme ya tiene toda la
   ruta resuelta. `cart-items` escucha `theme:cart:add` en document, toma
   `detail.button`, sube al <form> con closest, arma el FormData y llama a su
   addToCart -- que ademas pinta el error en [data-cart-errors-container] y
   refresca el drawer. Ese error importa aqui: /cart/add.js devuelve 422 si el
   cliente no tiene ubicacion asignada (app de inventario por ubicacion), y con
   un fetch propio ese 422 quedaria silencioso.

   POR QUE las pills NO llevan data-add-to-cart: el elemento quick-add-product
   del theme hace querySelector('[data-add-to-cart]') -- singular, primer match.
   Con el atributo, la primera pill quedaria enlazada dos veces (su listener y
   el mio) y agregaria dos piezas.

   POR QUE delegado en document: el cart drawer se re-renderiza por la API de
   secciones en cada cambio del carrito, asi que cualquier listener pegado a la
   pill muere en el primer add.
============================================================================ */
(function () {
  'use strict';

  document.addEventListener('click', function (evento) {
    var destino = evento.target;
    if (!destino || typeof destino.closest !== 'function') return;

    var pill = destino.closest('[data-gods-upsell-pill]');
    if (!pill) return;

    // el boton es type=submit a proposito: si este archivo no carga, el submit
    // nativo sigue agregando (POST a /cart/add y redireccion a /cart).
    evento.preventDefault();

    if (pill.hasAttribute('disabled') || pill.classList.contains('is-loading')) return;
    if (!pill.closest('form')) return;

    document.dispatchEvent(new CustomEvent('theme:cart:add', {
      detail: { button: pill },
      bubbles: false
    }));
  });
})();
